module.exports = __webpack_public_path__ + "images/apps/tencent-docs-text-701661b9728cd9abed75751ae47b32f3.png";